<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Breadcrumbs" pageTitle="Breadcrumbs" />
            <BreadcrumbsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import BreadcrumbsContent from '../Breadcrumbs/BreadcrumbsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'BreadcrumbsPage',
    components: {
        MainHeader,
        PageTitle,
        BreadcrumbsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>